<template>
	<div class="sufferer-merge-page">
		<div class="title">患者管理_编辑</div>
		<!-- <div class="desc">发现疑似相同患者，请判断是否为同一个，若是，选择信息后点击“确认合并”</div> -->
		<div class="sufferers-table">
			<a-table
        :scroll="{x:1600}"
        class="hospital-table"
        size="middle"
        :pagination="false"
        :rowKey="record => record.id"
        :locale="{emptyText:'暂无数据'}"
        :dataSource="editData"
			>
				<!-- <a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
				  <span class="table-th" slot="title">序号</span>
				</a-table-column> -->
				<!--<a-table-column :width="130" data-index="hosBarCode" key="hosBarCode">-->
				<!--<span class="hospital-required table-th" slot="title">协作组条码</span>-->
				<!--<template slot-scope="text, record">-->
				<!--<span style="margin: -5px 0;width: 130px">{{record.hosBarCode}}</span>-->
				<!--</template>-->
				<!--</a-table-column>-->
				<a-table-column width="7%" data-index="patientName" key="patientName">
					<span class="hospital-required table-th" slot="title">患者姓名</span>
					<template slot-scope="text, record">
						<div :class="{'has-error':isSubmit&&record.tstatus&&!record.patientName}">
							<a-input style="margin: -5px 0;width: 80px" v-model="record.patientName"/>
						</div>
					</template>
				</a-table-column>
				<a-table-column width="4%" data-index="sexName" key="sexName">
					<span class="table-th" slot="title">性别</span>
					<template slot-scope="text, record">
						<div :class="{'has-error':isSubmit&&record.tstatus&&!record.sexName}">
							<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" placeholder="请选择"
							          style="width: 60px" v-model="record.sexName">
								<a-select-option value="男">男</a-select-option>
								<a-select-option value="女">女</a-select-option>
							</a-select>
						</div>
					</template>
				</a-table-column>
				<a-table-column width="7%" data-index="clinicalDbId" key="clinicalDbId">
					<span class="table-th" slot="title">数据库ID</span>
					<template slot-scope="text, record">
						<a-input style="margin: -5px 0;width: 80px" v-model="record.clinicalDbId"/>
					</template>
				</a-table-column>
				<a-table-column width="8%" data-index="ageBirthDay" key="ageBirthDay">
					<span class="hospital-required table-th" slot="title">出生日期</span>
					<template slot-scope="text, record">
						<!-- <span>{{isSubmit}}+{{record.tstatus}}</span> -->
						<div :class="{'has-error':isSubmit&&record.tstatus&&!record.ageBirthDay}">
							<a-date-picker
                :disabledDate="disabledStartDate"
                style="width: 120px"
                v-model="record.ageBirthDay"
							/>
						</div>

						<!-- :defaultValue="record.ageBirthDay!=null?$moment(record.ageBirthDay, 'YYYY/MM/DD hh:mm:ss'):$moment('1970-01-00 00:00:00', "YYYY/MM/DD hh:mm:ss")" -->
					</template>
				</a-table-column>
				<a-table-column data-index="patientCardNo" key="patientCardNo">
					<span class="table-th" slot="title">身份证号</span>
					<template slot-scope="text, record">
						<a-input @blur='valite(record.patientCardNo)' style="margin: -5px 0;width: 150px"
						         v-model="record.patientCardNo"/>
						<!-- <span style="color:red" v-if='isCard(record.patientCardNo)'>请输入正确的身份证号</span> -->
					</template>
				</a-table-column>
				<a-table-column width="15%" data-index="address2" key="address2">
					<span class="table-th" slot="title">籍贯</span>
					<template slot-scope="text, record, index">
						<area-city :getPopupContainer="triggerNode => triggerNode.parentNode" @watchCity='getCityData'
						           :areaRecord='record' :recordIndex='index'></area-city>
						<!-- <div @click="clkDispiker(record)">
						  <v-distpicker   @selected="onSelected(data,record,index)" province="140000" @city="onChangeCity" @area="onChangeArea" :province="record.province" :city="record.city" :area="record.country"></v-distpicker>
					  </div> -->
					</template>
				</a-table-column>
				<a-table-column width="7%" data-index="age3" key="age3">
					<span class="hospital-required table-th" slot="title">疾病类型</span>
					<template slot-scope="text, record">
						<div :class="{'has-error':isSubmit&&record.tstatus&&!record.diseaseType}">
							<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" placeholder="请选择"
							          style="width: 80px" v-model="record.diseaseType">
								<a-select-option value="ALL">ALL</a-select-option>
								<a-select-option value="AML">AML</a-select-option>
							</a-select>
						</div>
					</template>
				</a-table-column>
				<a-table-column data-index="fatherName" key="fatherName">
					<span class="table-th" slot="title">父亲姓名</span>
					<template slot-scope="text, record">
						<a-input style="margin: -5px 0;width: 80px" v-model="record.fatherName"/>
					</template>
				</a-table-column>
				<a-table-column data-index="fatherPhone" key="fatherPhone">
					<span class="table-th" slot="title">父亲手机号</span>
					<template slot-scope="text, record">
						<a-input style="margin: -5px 0;width: 100px" v-model="record.fatherPhone"/>
					</template>
				</a-table-column>
				<a-table-column data-index="motherName" key="motherName">
					<span class="table-th" slot="title">母亲姓名</span>
					<template slot-scope="text, record">
						<a-input style="margin: -5px 0;width: 80px" v-model="record.motherName"/>
					</template>
				</a-table-column>
				<a-table-column data-index="motherPhone" key="motherPhone">
					<span class="table-th" slot="title">母亲手机号</span>
					<template slot-scope="text, record">
						<a-input style="margin: -5px 0;width: 100px" v-model="record.motherPhone"/>
					</template>
				</a-table-column>
			</a-table>
		</div>

		<div class="title" style="margin-top:40px;">编辑流程</div>
		<div class="sufferers-table">
			<a-table
        class="hospital-table"
        :pagination="false"
        :dataSource="editPatientData"
        :rowKey="record => record.id"
        :locale="{emptyText:'暂无数据'}"
        size="middle"
			>
				<a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
					<span class="table-th" slot="title">序号</span>
				</a-table-column>
				<a-table-column :width="130" data-index="hosBarCode" key="hosBarCode">
					<span class="hospital-required table-th" slot="title">协作组条码</span>
					<template slot-scope="text, record">
						<span style="margin: -5px 0;width: 130px">{{record.hosBarCode}}</span>
					</template>
				</a-table-column>
				<a-table-column data-index="hospitalName" key="hospitalName">
					<span class="table-th" slot="title">就诊医院</span>
				</a-table-column>

				<a-table-column data-index="patientNo" key="patientNo">
					<span class="table-th" slot="title">门诊号</span>
          <template slot-scope="text, record">
						<div>
							<a-input
                style="width: 100px"
                v-model="record.patientNo"
							/>
						</div>
					</template>
				</a-table-column>
				<a-table-column data-index="seeDoctorTime" key="seeDoctorTime">
					<span class="hospital-required table-th" slot="title">就诊日期</span>
					<template slot-scope="text, record, index">
						<div style="position:relative"
                :class="{'has-error':isSubmit&&record.tstatus&&!record.seeDoctorTime}">
							<a-date-picker
                style="width: 150px"
                :disabledDate="disabledStartDate"
                v-model="record.seeDoctorTime"
                @change='timeChange'
							/>
							<span class="help-line"
                  :class="{'err':isTag(record.seeDoctorTime,index)}">就诊日期不能小于出生日期</span>
						</div>
					</template>
				</a-table-column>
				<a-table-column data-index="deptName" key="deptName">
					<span class="table-th" slot="title">测序中心</span>
				</a-table-column>
				<a-table-column data-index="barCode" key="barCode">
					<span class="table-th" slot="title">测序中心条码</span>
				</a-table-column>
				<a-table-column data-index="applyItemNameDict" key="applyItemNameDict">
					<span class="table-th" slot="title">检验项目</span>
				</a-table-column>
				<a-table-column data-index="groupName" key="groupName">
					<span class="table-th" slot="title">专业组</span>
				</a-table-column>
				<a-table-column data-index="sampleTypeNameDict" key="sampleTypeNameDict">
					<span class="table-th" slot="title">标本类型</span>
				</a-table-column>
				<a-table-column data-index="sampleAmount" key="sampleAmount">
					<span class="table-th" slot="title">标本量</span>
				</a-table-column>
				<a-table-column data-index="sampleCollectionTime" key="sampleCollectionTime">
					<span class="table-th" slot="title">采样日期</span>
				</a-table-column>
			</a-table>
		</div>
		<div class="sufferers-btn">
			<a-button style="width:680px;" type="primary" @click="submitBtn()">确定</a-button>
		</div>
	</div>
</template>

<script>
  import moment from "moment";
  import AreaCity from '../../components/common/city'
  import {regAll} from "../../common/validate";

  export default {
    data() {
      return {
        editData: [], //编辑个人数据
        editPatientData: [], // 编辑流程数据
        isSubmit: true,
        editFromData: [],
        editPatientForm: [],
        isOk: false,
      };
    },
    components: {
      AreaCity
    },
    props: {
      list: {type: Object, default: {}}
    },
    methods: {
      disabledStartDate(startValue) {
        let endValue = new Date()
        // const endValue = endValue;
        if (!startValue || !endValue) {
          return false;
        }
        return startValue.valueOf() > endValue.valueOf();
      },
      isTag(time, index) {
        let date = ''
        if (this.editData.length > 0) {
          if (this.editData[0].ageBirthDay) {
            let tag = this.editData[0].ageBirthDay
            date = new Date(tag.format("YYYY-MM-DD")).getTime();
            if (time) {
              let dtime = new Date(time.format("YYYY-MM-DD")).getTime();
              if (Number(dtime) < Number(date)) {
                return true
              } else {
                return false
              }
            }
          }
        }
      },
      disabledEndDate(startValue) {
        if (this.editData.length > 0) {
          let endValue = ''
          if (this.editData[0].ageBirthDay) {
            let tag = this.editData[0].ageBirthDay
            endValue = new Date(tag)
            if (!startValue || !endValue) {
              return false;
            }
            return startValue.valueOf() > endValue.valueOf();
          }
        }
      },
      timeChange(time, timeString) {
        let date = ''
        let currentDate = new Date(time.format("YYYY-MM-DD")).getTime();
        if (this.editData.length > 0) {
          if (this.editData[0].ageBirthDay) {
            let tag = this.editData[0].ageBirthDay
            date = new Date(tag.format("YYYY-MM-DD")).getTime()
          }
          if (Number(currentDate) < Number(date)) {
            this.isOk = false
            // this.isSubmit=true
            this.$message.error('就诊日期不能小于出生日期')
          } else {
            this.isOk = true
          }
        }
      },
      ageChange(time, timeString) {
        let date = ''
        if (this.editData.length > 0) {
          if (this.editData[0].ageBirthDay) {
            let tag = this.editData[0].ageBirthDay
            date = new Date(tag).getTime()
          }
          if (time > date) {
            this.isOk = false
            // this.isSubmit=true
            this.$message.error('出生日期不能大于当前时间')
          } else {
            this.isOk = true
          }
        }
      },

      //验证身份证号
      isCard(value) {
        if (value) {
          if (!regAll.regCardNo.test(value)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      valite(value) {
        if (!this.isCard(value)) {
          this.$message.error('请输入正确的身份证号')
        }
      },
      // 编辑检查患者数据
      checkRowData(data) {
        this.editFromData = [];
        this.editData.forEach(item => {
          item.tstatus = false;
          var status = true;
          if (item.patientName != null || item.patientName != "") {
            status = false;
          }
          if (
            item.sexName != null ||
            item.sexName != undefined ||
            (item.ageBirthDay != null || item.ageBirthDay != undefined) ||
            (item.diseaseType != null || item.diseaseType != undefined)
          ) {
            status = false;
          }
          if (!status) {
            item.tstatus = true;
            var formObj = {};
            for (let keyName in item) {
              if (keyName != "rowId" && keyName != "tstatus") {
                formObj[keyName] = item[keyName];
              }
            }
            this.editFromData.push(formObj);

          }
        });
        //  this.editData = this.editData
        this.$set(this.editData, this, true)
      },
      getCityData(data) {
        let index = data.index
        let value = data.valueData
        this.editData[index].province = value[0]
        this.editData[index].city = value[1]
        this.editData[index].country = value[2]
      },
      //  end 结束方法
      // 编辑检查流程数据
      checkData(data) {
        this.editPatientForm = [];
        this.editPatientData.forEach(item => {
          item.tstatus = false;
          var status = true;
          if (item.seeDoctorTime == null || item.seeDoctorTime == undefined) {
            status = false;
          }
          if (!status) {
            item.tstatus = true;
            var formObj = {};
            for (let keyName in item) {
              if (keyName != "rowId" && keyName != "tstatus") {
                formObj[keyName] = item[keyName];
              }
            }
            this.editPatientForm.push(formObj);
            //  this.editPatientData =this.editPatientData
          }

        });
        this.$set(this.editPatientData, this, true)

      },
      // end结束方法
      getData() {
        let _this = this;
        this.$get("/patient/detail/" + this.list.id).then(res => {});
      },
      editPatient() {
        let _this = this;
        let wData = this.editPatientData
        wData
        this.$put("/patientitem/patientItem/batch", this.editPatientData, {
          headers: {
            "Content-Type": "application/json;charset:utf-8"
          }
        }).then(res => {
          // if (res.status == 200) {
          _this.$emit('getData')
          _this.$message.success("编辑信息成功");
          // setTimeout(() => {
          _this.$emit("close");
          // }, 2000);
          // }
        });
      },
      getPatient() {
        let _this = this
        this.$get("/patientitem/patientItem/currentPatientItem", {
          patientId: this.list.id
        }).then(res => {
          // this.editPatientData = JSON.parse(JSON.stringify(res.data.data));
          let newData = res.data.data.map(item => {
            if (item.seeDoctorTime) {
              // item.seeDoctorTime  = JSON.parse(JSON.stringify(item.seeDoctorTime))
              item.seeDoctorTime =
                moment(
                  item.seeDoctorTime,
                  "YYYY-MM-DD"
                )
              // item.seeDoctorTime = item.seeDoctorTime.format("YYYY-MM-DD");
              // return item;
            } else {
              item.seeDoctorTime = null;
            }
            return item;
          });
          this.editPatientData = newData
        });
      },
      editBatch() {
        let _this = this
        let newda = this.editPatientData
        let fromdata = this.editFromData[0]
        let tdata = newda.map((item) => {
          item.patientItemId = item.id;
          // let tag = item.seeDoctorTime.format("YYYY-MM-DD")
          //   item.seeDoctorTime =  tag
          if (item.seeDoctorTime) {
            item.tag = item.seeDoctorTime.format("YYYY-MM-DD")
          }
          for (let value in item) {
            if (value != 'patientItemId' && value != 'tag' && value != 'patientNo') {
              delete item[value]
            }
          }
          return item
        })
        fromdata.datas = tdata
        // fromdata.datas[0].seeDoctorTime=fromdata.datas[0].seeDoctorTime.format("YYYY-MM-DD")
        fromdata.datas.map(item => {
          item.seeDoctorTime = item.tag
          return item
        })
        if (fromdata.ageBirthDay) {
          fromdata.ageBirthDay = fromdata.ageBirthDay.format("YYYY-MM-DD")
        }
        this.$put("/patient/updatePatientAndPatientItem", fromdata, {
          headers: {
            "Content-Type": "application/json;charset:utf-8"
          }
        }).then(res => {
          if (res.data.code == 1) {
            _this.$emit('getData')
            _this.$message.success("编辑信息成功");
            // setTimeout(() => {
            _this.$emit("close");
          } else {
            this.$message.error(res.data.error)
          }
        });
      },
      submitBtn() {
        this.isSubmit = true;
        this.checkRowData(this.editData);

        this.checkData(this.editPatientData);
        this.$nextTick(() => {
          var errList = document.querySelectorAll(".has-error");
          var err = document.querySelectorAll(".err");
          if (err.length == 0) {
            if (errList.length == 0) {
              this.editBatch();
            }
          } else {
            this.$message.error('出生日期不能大于当前时间')
          }

        });
      }
    },
    created() {
      this.getPatient();
      let newList = [];
      newList.push(this.list);
      let newData = newList.map(item => {
        if (item.ageBirthDay != null || item.ageBirthDay != undefined) {
          item.ageBirthDay = moment(
            item.ageBirthDay,
            "YYYY-MM-DD"
          );
          return item;
        } else {
          item.ageBirthDay = null;
          return item;
        }
      });
      this.editData = newData;
      //  for(let val of dataList){
      //      val.ageBirthDay = moment(val.ageBirthDay, 'YYYY/MM/DD hh:mm:ss')
      //  }
      // this.getDirt("sampleType").then(data => {
      //   this.sampleTypes = data.rows;
      // });
      // this.getDirt("applyItem").then(data => {
      //   this.applyItems = data.rows;
      // });
    }
  };
</script>

<style lang="scss" scoped>
	.help-line {
		display: none;
		position: absolute;
		top: 30px;
	}

	.err {
		display: block;
		color: red;
	}

	.sufferer-merge-page {
		width: 100%;
		height: 100%;
		background: #fff;
		padding: 80px 40px 40px 40px;
		position: relative;
		overflow: auto;
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.desc {
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(164, 164, 164, 1);
			margin: 20px 0 0 0;
		}
		.sufferers-table {
			margin-top: 20px;
		}
		.sufferers-btn {
			margin: 50px 0;
			text-align: center;
		}
	}
</style>